module.exports = __webpack_public_path__ + "Flag-584.c24bde56ba2b03433ee38c1ca3f79574.svg";